export const validateName = (rule, value, callback) => {
    // Use a regular expression to allow letters, numbers, and spaces
    if (!/^[A-Za-z\s]+$/.test(value)) {
      callback('Only letters are allowed.');
    } else {
      callback();
    }
  };